import { IEventTickets, IParticipantData } from 'interfaces/attendanceList';
import { IEvent } from 'interfaces/event';
import { ISheetInfo } from 'interfaces/sheet';
import * as Rx from 'rxjs';
import RxOp from 'rxjs-operators';

import apiService, { ApiService } from '../api';
import { SetTicketRepresentedResponse } from './types';

export class AttendanceListService {
  constructor(private apiService: ApiService) {
    this.apiService = apiService;
  }

  public handleErrorMessage(err: any) {
    this.apiService.handleErrorMessage(err);
  }

  // temp

  public getMyEvents(): Rx.Observable<IEvent[]> {
    return this.apiService.get('/attendance_list/list_my_tickets_events').pipe(RxOp.map(response => response.data));
  }

  //---

  public listPastEvents(params?: any): Rx.Observable<any> {
    return this.apiService
      .post('/attendance_list/events_list_past', params)
      .pipe(RxOp.map(response => response.data[0]));
  }

  public listCurrentEvents(params?: any): Rx.Observable<any> {
    return this.apiService
      .post('/attendance_list/events_list_current', params)
      .pipe(RxOp.map(response => response.data[0]));
  }

  public getEventImage(eventId: string): Rx.Observable<any> {
    return this.apiService.get(`/event_services/image/${eventId}`).pipe(RxOp.map(response => response.data));
  }

  public getParticipantData(eventId: string, attendanceId: string): Rx.Observable<any> {
    return this.apiService
      .get(`/attendance_list/get_participant/${eventId}/${attendanceId}`)
      .pipe(RxOp.map(response => response.data));
  }
  public getEventTickets(eventId: string): Rx.Observable<IEventTickets[]> {
    return this.apiService.get(`/attendance_list/list_my_tickets/${eventId}`).pipe(RxOp.map(response => response.data));
  }

  public list(data?: any): Rx.Observable<any> {
    const filter = {
      ...data,
      only_first_last_name: true,
    };
    return this.apiService.post('/attendance_list/list_grouped', filter).pipe(RxOp.map(response => response.data[0]));
  }

  public setAsMine(data: any): Rx.Observable<any> {
    return this.apiService.post('/attendance_list/set_as_mine', data);
  }

  public unlinkTicket(data: any): Rx.Observable<any> {
    return this.apiService.post('/attendance_list/unlink_ticket/', data);
  }

  public transferTicket(data: any): Rx.Observable<any> {
    return this.apiService.post('/attendance_list/transfer_ticket', data);
  }

  public resendTicket(data?: any): Rx.Observable<any> {
    return this.apiService.post('/attendance_list/send_ticket_again', data);
  }

  public resendTicketMultiple(data?: any): Rx.Observable<any> {
    return this.apiService.post('/attendance_list/resend_tickets_bulk', data);
  }

  public attendanceDetailByEvent(eventId: string, cliCod: string): Rx.Observable<any> {
    return this.apiService
      .get(`/attendance_list/attendance_detail_by_event/${eventId}/${cliCod}`)
      .pipe(RxOp.map(response => response.data));
  }

  public detail(attendanceId: string): Rx.Observable<any> {
    return this.apiService.get(`/attendance_list/detail/${attendanceId}`).pipe(RxOp.map(response => response.data[0]));
  }

  public presenceConfirm(attendanceId: string): Rx.Observable<any> {
    return this.apiService.get(`/presence/confirm/${attendanceId}`);
  }

  public createTransferLink(attendanceListId: string): Rx.Observable<any> {
    return this.apiService.post('/attendance_list/create_transfer_link', {
      id: attendanceListId,
    });
  }

  public getTransferTicket(attendanceListId: string): Rx.Observable<{ link: string }> {
    return this.apiService
      .get(`/attendance_list/transfer_link/${attendanceListId}`)
      .pipe(RxOp.map(response => response.data));
  }

  public importSheet(sheetInfo: ISheetInfo): Rx.Observable<any> {
    return this.apiService.post('/attendance_list/import_sheet', sheetInfo);
  }

  public cancelTicketTransferLink(inviteKey: string): Rx.Observable<any> {
    return this.apiService.delete(`/attendance_list/delete_links/${inviteKey}`);
  }

  public checkGiftTicketToken(token: string): Rx.Observable<any> {
    return this.apiService.get(`/attendance_list/validate_transfer_link/${token}`);
  }

  public claimGiftTicket(token: string, data: any): Rx.Observable<any> {
    return this.apiService.post(`/attendance_list/edit_by_link/${token}`, data);
  }

  public setTicketRepresented(eventId: string, data: SetTicketRepresentedResponse): Rx.Observable<boolean> {
    return this.apiService.post(`/attendance_list/ticket/represented/${eventId}`, data);
  }

  public getParticipantDataByCipherText(ciphertext: string, utmSource?: string): Rx.Observable<IParticipantData[]> {
    let url = `/attendances/user_tickets/${ciphertext}`;
    if (utmSource) {
      url = `${url}?utm_source=${utmSource}`;
    }
    return this.apiService.get(url).pipe(RxOp.map(response => response.data));
  }

  public getEventByFatcod(fatCod: string): Rx.Observable<{ event_id: string }> {
    return this.apiService.get(`/attendance_list/get_event_id/${fatCod}`).pipe(RxOp.map(response => response.data));
  }
}

const attendanceListService = new AttendanceListService(apiService);
export default attendanceListService;
